<template>
  <div
    v-if="images"
    class="screensaver"
    @click="onClick"
  >
    <v-carousel
      cycle
      width="100%"
      height="100%"
      hide-delimiter-background
      show-arrows-on-hover
      :show-arrows="false"
      hide-delimiters
    >
      <v-carousel-item
        v-for="(image, i) in images"
        :key="i"
        :src="image"
      />
    </v-carousel>
  </div>
</template>
<script>
export default {
  name: 'CustomCarousel',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    images: {
      type: Array,
      defautl: null,
    },
  },
}
</script>
<style scoped>
.screensaver {
  height: calc(100vh);
  background-color: white;
}
</style>
